import { c as _c } from "react/compiler-runtime";
import { EmptyStateSearchIcon } from '@systemeio/icons';
import { useAffiliateActivity } from 'modules/affiliate-dashboard/hooks/use-affiliate-activity';
import { AffiliateEmptyStateEnum } from 'modules/affiliate/enums/affiliate-empty-state-enum';
import { AffiliateSection } from 'modules/affiliate/types/affiliate-section';
import { getAffiliateEmptyState } from 'modules/affiliate/utils/get-affiliate-empty-state';
import { EmptyStateProps } from 'shared/components/empty-states';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
export const useAffiliateDashboardEmptyState = (section, t0) => {
  const $ = _c(37);
  const {
    data,
    isFiltered
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    hasCommissions,
    hasLeads,
    isLoading
  } = useAffiliateActivity();
  const t1 = section === "leads" ? hasLeads : hasCommissions;
  let t2;
  if ($[0] !== data || $[1] !== isFiltered || $[2] !== isLoading || $[3] !== t1) {
    t2 = getAffiliateEmptyState({
      data,
      hasActivity: t1,
      isActivityLoading: isLoading,
      isFiltered
    });
    $[0] = data;
    $[1] = isFiltered;
    $[2] = isLoading;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    emptyState,
    tableData
  } = t2;
  const keyPrefix = `dashboard.affiliate_dashboard.${section}`;
  const t3 = `${keyPrefix}.empty.title`;
  let t4;
  if ($[5] !== t || $[6] !== t3) {
    t4 = t(t3);
    $[5] = t;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `${keyPrefix}.empty.description`;
  let t6;
  if ($[8] !== t || $[9] !== t5) {
    t6 = t(t5);
    $[8] = t;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = {
      title: t4,
      description: t6
    };
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `${keyPrefix}.empty_match.title`;
  let t9;
  if ($[14] !== t || $[15] !== t8) {
    t9 = t(t8);
    $[14] = t;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("global.filter_range.change_filters");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = {
      icon: EmptyStateSearchIcon,
      title: t9,
      description: t10
    };
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = `${keyPrefix}.empty_filter.title`;
  let t13;
  if ($[22] !== t || $[23] !== t12) {
    t13 = t(t12);
    $[22] = t;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t) {
    t14 = t("global.filter_range.change_date_range");
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t13 || $[28] !== t14) {
    t15 = {
      icon: EmptyStateSearchIcon,
      title: t13,
      description: t14
    };
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t11 || $[31] !== t15 || $[32] !== t7) {
    t16 = {
      [AffiliateEmptyStateEnum.NoActivity]: t7,
      [AffiliateEmptyStateEnum.NoMatch]: t11,
      [AffiliateEmptyStateEnum.NoPeriodData]: t15
    };
    $[30] = t11;
    $[31] = t15;
    $[32] = t7;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const emptyStateProps = t16;
  const t17 = emptyStateProps[emptyState];
  let t18;
  if ($[34] !== t17 || $[35] !== tableData) {
    t18 = {
      tableData,
      emptyStateProps: t17
    };
    $[34] = t17;
    $[35] = tableData;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
};